import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config

const axios_token = axios.create({
  baseURL: window.base_url,
});

axios_token.centralerror = function (app, return_error = false) {
  return function (error) {
    let message = "Si è verificato un errore";

    if (error.response) {
      // Errore di risposta HTTP con codice di stato
      const statusCode = error.response.status;

      switch (statusCode) {
        case 400:
          message = "\nLa richiesta non è valida.\nSi prega di riprovare.";
          break;
        case 401:
          message =
            "\nNon sei autorizzato ad accedere a questa risorsa.\nSi prega di effettuare l'accesso o contattare l'assistenza.";
          break;
        case 403:
          message =
            "\nAccesso negato.\nNon hai i permessi necessari per accedere a questa risorsa.";
          break;
        case 404:
          message = "\nLa risorsa richiesta non è stata trovata.";
          break;
        case 500:
          message =
            "\nSi è verificato un errore interno del server.\nSi prega di riprovare più tardi o contattare l'assistenza.";
          break;
        default:
          message =
            "\nErrore non gestito.\nSi prega di contattare l'assistenza.";
          console.error("Errore non gestito:", error);
          break;
      }
    } else if (error.code) {
      const errorCode = error.code;

      switch (errorCode) {
        case "ERR_NETWORK":
          message = "Impossibile contattare il server";
          break;
        default:
          message = "Nessuna risposta dal server :" + errorCode;
          console.error("Nessuna risposta dal server:", error);
          break;
      }
    } else {
      // Errore generico senza risposta HTTP
      message = "\nErrore non gestito.\nSi prega di contattare l'assistenza.";
      console.error("Errore non gestito:", error);
    }
    app.$bvToast.toast(message, {
      title: "Errore",
      autoHideDelay: 5000,
      appendToast: true,
    });
    if (return_error) return error;
  };
};

axios_token.interceptors.request.use(
  function (config) {
    let token = localStorage.getItem("auth_token");

    if (token) {
      // console.log("request with token", token)
      config.headers["Authorization"] = `Token ${token}`;
    } /*else {
            console.log("request without token", token)
        }*/
    config.headers["accept"] = "application/json";
    config.headers["X-Requested-With"] = Math.random()
      .toString(36)
      .substring(7);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios_token.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
export default axios_token;
